export default __webpack_public_path__ + "static/media/Rambam.e17e7afb.jpg";